import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CreateFolderButtonWrapper = styled.div`
  padding: ${Spacing.S16};
`
